import { useEffect, useRef } from 'react';

export function useSectionVisibility(id, onVisible, isEnabled = true, threshold = 0.6) {
  const ref = useRef(null);

  useEffect(() => {
    if (!isEnabled || !ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onVisible(id);
        }
      },
      { threshold }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [id, isEnabled, onVisible, threshold]);

  return ref;
}
